import { render, staticRenderFns } from "./DocumentSign.vue?vue&type=template&id=0f672e53&scoped=true&"
import script from "./DocumentSign.vue?vue&type=script&lang=js&"
export * from "./DocumentSign.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSign.vue?vue&type=style&index=0&id=0f672e53&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f672e53",
  null
  
)

export default component.exports